import ApplicationController from 'javascript/controllers/application_controller';

export default class extends ApplicationController {
  initialize() {
    if (!window.ApplePaySession) {
      this.element.remove();
    }
  }
}
